import Copyright from "./Copyright";

export default function Footer({footerBg, home}) {
  return (
      <footer className={`ltn__footer-area ltn__footer-2  ${footerBg === "dark" ? "ltn__footer-color-1" : "ltn__footer-color-2"}`}>
        <Copyright footerBg={footerBg} home={home}/>
      </footer>
  );
};
